export const mobileMax = "409px";
export const tablet = "410px";
export const tabletMax = "768px";